/**
 * @file PickingConfirmDialog.tsx
 * @description Подтверждение опасного действия над заданием на сборку
 * (выделено из `PickingTaskActions` в phase19.23).
 *
 * Текст берётся из реестра `PICKING_CONFIRM_TEXT` — меню задания и кнопка
 * «Пересобрать задание» в полосе-подсказке показывают одно и то же обещание.
 */

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../ui/alert-dialog";
import { Button } from "../../ui/button";
import {
  PICKING_CONFIRM_TEXT,
  type PickingConfirmKind,
} from "./picking-confirm-text";

interface Props {
  /** null — диалог закрыт. */
  kind: PickingConfirmKind | null;
  busy: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function PickingConfirmDialog({ kind, busy, onCancel, onConfirm }: Props) {
  const text = kind ? PICKING_CONFIRM_TEXT[kind] : null;
  return (
    <AlertDialog open={text !== null} onOpenChange={(v) => (!v ? onCancel() : null)}>
      <AlertDialogContent fullScreen className="max-w-md gap-3">
        <AlertDialogHeader>
          <AlertDialogTitle>{text?.title}</AlertDialogTitle>
          <AlertDialogDescription>{text?.description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="ghost" className="min-h-12" onClick={onCancel} disabled={busy}>
            Не сейчас
          </Button>
          <Button
            variant={kind === "cancel" ? "destructive" : "default"}
            className="min-h-12"
            onClick={onConfirm}
            disabled={busy}
          >
            {text?.action}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
